/**
 * Mirror of backend LogicFlowTraceStatusEnum.
 * Ordinals MUST match the backend definition (RUNNING=0, SUCCESS=1, FAILED=2).
 *
 * @ticket TM-1000001563
 */
export enum LogicFlowTraceStatusEnum {

    RUNNING,
    SUCCESS,
    FAILED,
}
